import React from 'react';
import {Panel} from 'primereact/panel';
import IncidentService from '../../shared/service/IncidentService';
import IncidentColumn from '../../shared/component/dataTable/columns/IncidentColumn';
import {PAGE_MODE} from "../../shared/utils/Constants";
import Incident from "./Incident";
import Dialog from "../../shared/component/dialog/Dialog";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import DataTableRequest from "../../shared/component/dataTable/DataTableRequest";
import {Calendar} from "primereact/calendar";
import {toast} from "react-toastify";

export default class IncidentList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            pageMode: null,
            dialogHeader: 'Arıza Bilgileri',
            dateStart: null,
            dateEnd: null
        };
        this.service = new IncidentService();
    }

    componentDidMount = () => {
        this.init();
    }

    render() {
        const tr = {
            firstDayOfWeek: 1,
            monthNames: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
            monthNamesShort: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
            dayNames: ['Pazartesi,', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar'],
            dayNamesShort: ['Pzt', 'Sal', 'Çar', 'Prş', 'Cm', 'Cmr', 'Paz'],
            dayNamesMin: ['P', 'S', 'Ç', 'P', 'C', 'Ct', 'Pz'],
            today: ['Bugün'],
            clear: ['Temizle']
        };

        return (
            <Panel header="Arıza Yönetimi">
                <div className="container-fluid">
                    <h3>Filtre</h3>
                    <div className="row">
                        <div className="col-4" style={{ padding: 0 }}>
                            <div style={{ width: 300 }}>
                                <div className="p-grid p-fluid">
                                    <Calendar
                                        tooltip="Talep Başlangıç Tarihi"
                                        placeholder="Talep Başlangıç Tarihi Seç"
                                        value={this.state.dateStart}
                                        onChange={({ value }) => {
                                            const dateEnd = this.state.dateEnd || new Date();
                                            this.setState({ dateStart: value, dateEnd }, this.refresh);
                                        }}
                                        dateFormat="dd/mm/yy"
                                        showButtonBar
                                        readOnlyInput
                                        showIcon
                                        locale={tr}
                                        required
                                        style={{ margin: 20 }}
                                        onClearButtonClick={() => this.setState({ dateStart: "" })}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-4" style={{ padding: 0 }}>
                            <div style={{ width: 300 }}>
                                <div className="p-grid p-fluid">
                                    <Calendar
                                        tooltip="Talep Bitiş Tarihi"
                                        placeholder="Talep Bitiş Tarihi Seç"
                                        value={this.state.dateEnd}
                                        onChange={e => this.setState({ dateEnd: e.value }, this.refresh)}
                                        dateFormat="dd/mm/yy"
                                        showButtonBar={true}
                                        readOnlyInput={true}
                                        showIcon={true}
                                        locale={tr}
                                        required={true}
                                        style={{ margin: 20 }}
                                        onClearButtonClick={e => this.setState({ dateEnd: "" })}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <DataTableRequest
                    ref={(elem) => this.refDataTable = elem}
                    fields={IncidentColumn.fields}
                    dataURL="incident/findAllFiltered"
                    objectName={IncidentColumn.name}
                    selectionMode="single"
                    onDataSelect={this.onDataSelect}
                    loading={this.state.loading}
                    export={true}
                    autoLoad={false}
                    onExport={this.exportXLSX}
                />

                <Dialog visible={this.state.displayDialog} header={this.state.dialogHeader}
                        onHide={() => this.setState({displayDialog: false})} style={{width: '100%'}}>
                    <Incident  ref={elem => this.refIncident = elem} closeDialog={() => this.setState({displayDialog: false})} refresh={this.refresh}/>

                </Dialog>
            </Panel>
        );
    }

    refresh = () => {
        this.init();
        // this.refDataTable.setParameter("ALL", GeneralUtils.getContactId());
    }

    init = () => {
        const { dateStart, dateEnd } = this.state;
        const parameter = window.location.href.split('?')[1];
        const contactId = GeneralUtils.getContactId();

        if ((dateStart && !dateEnd) || (!dateStart && dateEnd)) {
            toast.warn("Lütfen Başlangıç ve Bitiş Tarihi Alanlarını Doldurunuz.");
            this.setState({ loading: false });
            return;
        }

        let startDate = null;
        let endDate = null;

        if (dateStart && dateEnd) {
            if (!this.controlDateRange(dateStart, dateEnd)) {
                this.setState({ loading: false });
                return;
            }
            startDate = this.formatDate(dateStart);
            endDate = this.formatDate(dateEnd);
        }

        if (parameter) {
            const values = parameter.split('&');
            const name = values[0]?.split('=')[1];
            const subcategoryId = values[1]?.split('=')[1];
            const status = values[2]?.split('=')[1];

            if (!GeneralUtils.isNullOrEmpty(name) && !GeneralUtils.isNullOrEmpty(subcategoryId) && !GeneralUtils.isNullOrEmpty(status)) {
                if (startDate && endDate) {
                    this.refDataTable.setParameter(startDate, endDate, name, contactId, subcategoryId, status);
                } else {
                    this.refDataTable.setParameter(name, contactId, subcategoryId, status);
                }
            } else if (!GeneralUtils.isNullOrEmpty(name)) {
                if (startDate && endDate) {
                    this.refDataTable.setParameter(startDate, endDate, name, contactId);
                } else {
                    this.refDataTable.setParameter(name, contactId);
                }
            }
        } else {
            if (startDate && endDate) {
                this.refDataTable.setParameter(startDate, endDate, "ALL", contactId);
            } else {
                this.refDataTable.setParameter("ALL", contactId);
            }
        }
    };


    onDataSelect = (data) => {
        let dialogHeader = data.id +' Numaralı Arıza Kaydı';
        this.setState({displayDialog: true, pageMode: PAGE_MODE.VIEW, activeIndex: 0, dialogHeader: dialogHeader});
        this.refIncident.refAttachedDocument.clearAllDataAndFileArray();
        this.refIncident.setData(Object.assign({}, data), PAGE_MODE.VIEW);
        this.refIncident.setDisabledFlagIncidentFollow(PAGE_MODE.VIEW,data.id);
    }

    controlDateRange = (dateStart, dateEnd) => {
        const now = new Date();

        if (dateStart > now || dateEnd > now) {
            toast.warn("Başlangıç ve/veya bitiş tarihi bugünün tarihinden ileri olamaz.");
            return false;
        }

        if (dateStart > dateEnd) {
            toast.warn("Başlangıç tarihi, bitiş tarihinden sonra olamaz.");
            return false;
        }

        return true;
    };

    formatDate = (date) => {
        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }



    exportXLSX = () => {
        const { dateStart, dateEnd } = this.state;

        if (!dateStart || !dateEnd) {
            toast.warn("Lütfen başlangıç ve bitiş tarihlerini seçiniz.");
            return;
        }

        if (!this.controlDateRange(dateStart, dateEnd)) {
            return;
        }

        const oneMonth = 31 * 24 * 60 * 60 * 1000;
        const diff = dateEnd - dateStart;
        if (diff > oneMonth) {
            toast.warn("Tarih aralığı  1 aydan fazla olamaz.");
            return;
        }

        this.refDataTable.exportXLSX();
    }


}
